import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {BaseVehicle} from '../../types/BaseVehicle';
import {MechanicalReplacementServiceIntervals} from '../../types/RentalVehicle';

export interface FormCalculateNextReplacementMileageActionParams {
  form: UseFormReturn<BaseVehicle>;
  name: MechanicalReplacementServiceIntervals;
  value: number | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for calculating the next replacement mileage for a vehicle component.
 * Uses the last replacement mileage and replacement interval to calculate the next mileage.
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance and component name
 */
export const formCalculateNextReplacementMileageAction = (
  _context: unknown,
  params: FormCalculateNextReplacementMileageActionParams
): void => {
  const {form, name, value} = params;

  const lastReplacementMileage = value;
  const replacementAfterMileage = form.getValues(
    `serviceIntervals.${name}.replacementAfterMileage`
  );

  if (!lastReplacementMileage || !replacementAfterMileage) {
    return;
  }

  const nextMileage = lastReplacementMileage + replacementAfterMileage;
  form.setValue(`serviceIntervals.${name}.nextReplacementMileage`, nextMileage, DEFAULT_OPTIONS);
};
